import { useAuth } from "@/contexts/AuthContext";
import { lazy, Suspense } from "react";

const LandingPage = lazy(() => import("./LandingPage"));
const Index = lazy(() => import("./Index"));

const HomePage = () => {
  const { session, loading } = useAuth();

  if (loading) {
    return <div className="min-h-screen bg-background" />;
  }

  return (
    <Suspense fallback={<div className="min-h-screen bg-background" />}>
      {session ? <Index /> : <LandingPage />}
    </Suspense>
  );
};

export default HomePage;
